import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import fr from "vuetify/lib/locale/fr";

import light from "./pharmatColors";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fr },
    current: "fr",
  },
  theme: {
    themes: { light },
    options: { customProperties: true },
  },
  breakpoint: {
    mobileBreakpoint: "sm", // This is equivalent to a value of 960
  },
});
